import * as ActionType from "../actionTypes";

export default (state = {}, action) => {
  switch(action.type){
    case ActionType.REQUEST_SINGLE_GET_EXAMINATION_DETAILS :

        return{
            ...state,
            loading:true,
            errorInfo:null,
            error:false
            
            }
    case ActionType.RECEIVED_SINGLE_GET_EXAMINATION_DETAILS :
        return{
            ...state,
            loading:false,
            errorInfo:null,
            error:false,
            response:action.res.data

        }
    case ActionType.ERROR_SINGLE_GET_EXAMINATION_DETAILS :
        return{
            ...state,
            loading:false,
            errorInfo:action.err,
            error:true
        }
    case ActionType.CLEAR_SINGLE_GET_EXAMINATION_DETAILS :
        return{
        }
    default : 
      return state    

  }
}